import { render, staticRenderFns } from "./InvestorPhone.vue?vue&type=template&id=e653e49c&"
import script from "./InvestorPhone.vue?vue&type=script&lang=js&"
export * from "./InvestorPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports